import { isArray } from 'lodash'

function deepMerge(target, source) {
  const output = { ...target } // Create a shallow copy of the target

  for (const key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (
        typeof source[key] === 'object' &&
        source[key] !== null &&
        !isArray(source[key]) &&
        typeof output[key] === 'object' &&
        output[key] !== null &&
        !isArray(output[key])
      ) {
        // If both values are objects, recursively deep merge them
        output[key] = deepMerge(output[key], source[key])
      } else if (isArray(source[key]) && isArray(output[key])) {
        // If both values are arrays, you'll need to decide how to merge them.
        // For example, you might concatenate them, or deep merge by a sub-key
        // if the array elements are objects with a common identifier.
        // For simplicity here, we'll just replace the array.
        output[key] = source[key]
      } else {
        // Otherwise, simply assign the source value
        output[key] = source[key]
      }
    }
  }
  return output
}

function mergeArraysByKey(targetArray, sourceArray, key) {
  const mergedArray = [...targetArray] // Create a copy to avoid modifying the original

  sourceArray.forEach((sourceItem) => {
    const targetItemIndex = mergedArray.findIndex(
      (targetItem) => targetItem[key] === sourceItem[key],
    )

    if (targetItemIndex !== -1) {
      // If a matching item is found in the target array, deep merge its properties
      mergedArray[targetItemIndex] = deepMerge(mergedArray[targetItemIndex], sourceItem)
    } else {
      // If no matching item is found, add the source item to the merged array
      mergedArray.push(sourceItem)
    }
  })

  return mergedArray
}

export default mergeArraysByKey
